const EXACT_NOINDEX_ROUTES = new Set([
  '/transfer-builder-setup',
  '/lineup-builder',
  '/tactics-board',
  '/38-0/play',
  '/38-0/gauntlet',
  '/38-0/gauntlet/daily',
  '/38-0/packs',
  '/38-0/daily',
  '/champions-xi/daily',
  '/world-xi-cup/classic',
  '/world-xi-cup/daily',
  '/world-xi-cup/pack-draft',
  '/card-clash/daily',
  '/squad-builder/daily',
  '/budget-squad/daily',
  '/tier-list/create',
]);

const NOINDEX_PATTERNS = [
  /^\/summary(?:\/|$)/,
  /^\/budget-squad\/build(?:\/|$)/,
  /^\/tier-list\/(?:share|custom)(?:\/|$)/,
  /^\/tier-list\/[^/]+$/,
  /^\/card-clash\/(?:decks|debug-decks|review)(?:\/|$)/,
  /^\/world-xi-cup\/(?:legend-preview|perfect-result-preview)(?:\/|$)/,
  /^\/analyst\/[^/]+\/[^/]+(?:\/[^/]+)?$/,
];

export function normalizeIndexingPath(pathname) {
  const rawPath = String(pathname || '/').split(/[?#]/, 1)[0] || '/';
  return rawPath === '/' ? '/' : rawPath.replace(/\/+$/, '');
}

export function isNoIndexRoute(pathname) {
  const normalizedPath = normalizeIndexingPath(pathname);
  return EXACT_NOINDEX_ROUTES.has(normalizedPath)
    || NOINDEX_PATTERNS.some((pattern) => pattern.test(normalizedPath));
}
